export default __webpack_public_path__ + "static/media/Thug's Tunic of Charred Earth.169adec6.jpg";